export const classes = {
  wrapper:
    'flex items-center gap-2 rounded-lg px-2 py-1 cursor-pointer hover:bg-black/5 dark:hover:bg-white/5',
  label: 'select-none leading-tight',
  name: 'text-sm font-semibold text-taupe-3 dark:text-mauve-1',
  menuItem: 'py-1 mx-2',
  header: 'flex items-center gap-3 px-4 pb-3 pt-2',
  headerInfo: 'min-w-0 leading-tight',
  headerName: 'text-sm font-semibold text-taupe-3 dark:text-mauve-1',
  headerEmail: 'truncate text-xs text-taupe-2 dark:text-mauve-2',
  sectionLabel:
    'px-4 pb-1 pt-2 text-[0.65rem] font-semibold uppercase tracking-wide text-taupe-1 dark:text-mauve-3',
  appearance: 'px-3 py-1 mb-2',
};
